import menuBtn from './menuBtn';
import formValidate from './formValidate';

menuBtn.init();
formValidate.init();
